<template>
  <div class="controlContainer">
    <div class="controlInnerContainer">
      <div class="column">
        <div class="img fastBack" @click="changeMultiple(-1)"></div>
        <label>快退</label>
      </div>
      <div class="column">
        <div
          class="img playOrPause"
          :class="{ isStop: isModifyPlay }"
          @click="playOrPause"
        ></div>
        <label>{{ playOrPauseName }}</label>
      </div>
      <div class="column">
        <div class="img fastForward" @click="changeMultiple(1)"></div>
        <label>快进</label>
      </div>
      <div class="column">
        <div class="img end" @click="resetFly"></div>
        <label>停止</label>
      </div>
    </div>
  </div>
</template>

<script type="text/javascript">
import playImg from "../../../assets/img/map/route/play.png";
import stopImg from "../../../assets/img/map/route/stop.png";

export default {
  name: "RoutePlanningPlay",
  data() {
    return { playOrPauseName: "播放" };
  },
  props: ["isModifyPlay"],
  methods: {
    playOrPause() {
      const isModifyPlay = !this.isModifyPlay;
      this.$emit("changeModifyPlay", isModifyPlay);
    },
    changeMultiple(count) {
      this.$emit("changeMultiple", count);
    },
    resetFly() {
      this.$emit("resetFly");
    },
  },
  watch: {
    isModifyPlay(nval, oval) {
      if (nval) {
        this.$data.playOrPauseName = "暂停";
      } else {
        this.$data.playOrPauseName = "播放";
      }
    },
  },
};
</script>
<style scoped>
@import "../../../assets/css/mapCss/routePlanningPlay.css";
</style>



// WEBPACK FOOTER //
// src/components/home/taskplan/RoutePlanningPlay.vue